/* unplugin-vue-components disabled */import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=3bc43bd7&lang=scss"

const __exports__ = script;

export default __exports__